module.exports = __webpack_public_path__ + "static/media/placeholder8.ffb10e83.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder8.jpg
// module id = 630
// module chunks = 0